import { toast } from 'react-toastify'

import { User } from '@/models/user'
import api from '@/shared/api'
import { clearAuthTokenCookie, setAuthTokenCookie } from '@/shared/authCookies'
import { ENDPOINTS } from '@/shared/constants'
import { clearHiddenNotificationHighlightIds } from '@/shared/notificationHighlightsStorage'
import { logged } from '@/store/features/authSlice'
import { useAppDispatch } from '@/store/hooks'

export default function useAuthApi() {
  const dispatch = useAppDispatch()

  async function login(email: string, password: string) {
    let accessToken: string

    try {
      const res = await api.post(ENDPOINTS.AUTH.POST.LOGIN, { email, password })
      accessToken = res.data.accessToken
    } catch {
      toast.error('Email ou senha incorreto')
      return null
    }

    setAuthTokenCookie(accessToken)

    try {
      const profileRes = await api.get<User>(ENDPOINTS.USERS.GET.PROFILE, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      clearHiddenNotificationHighlightIds(profileRes.data.id)
      dispatch(logged(profileRes.data))
      return profileRes.data
    } catch {
      clearAuthTokenCookie()
      toast.error('Erro ao carregar perfil. Tente novamente')
      return null
    }
  }

  return { login }
}
